import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { CheckCircleIcon as CheckCircleSolid } from '@heroicons/react/24/solid';

const steps = [
  { label: 'Create products or services', to: '/product?guide=true', key: 'products' },
  { label: 'Add employees to your shop', to: '/employees?guide=true', key: 'employees' },
  { label: 'Download POS or HandPad app', to: '/download?guide=true', key: 'download' },
  { label: 'Generate PIN & token', to: '/register-info?guide=true', key: 'pin' },
];

const HelpGuide = ({ products, employeeList, currentUser }: any) => {
  const doneMap: Record<string, boolean> = {
    products:  (products?.products?.length ?? 0) > 0,
    employees: (employeeList?.employees?.length ?? 0) > 0,
    download:  (currentUser?.didDownload ?? 0) > 0,
    pin:       (currentUser?.didPinToken ?? 0) > 0,
  };
  const doneCount = Object.values(doneMap).filter(Boolean).length;
  const pct = Math.round((doneCount / steps.length) * 100);

  return (
    <div className="bg-white border border-lavender rounded-2xl shadow-sm p-6 flex flex-col gap-5 h-full">
      <div>
        <p className="text-xs font-semibold text-echo-blue uppercase tracking-wider mb-1">Setup</p>
        <h2 className="text-base font-semibold text-valhalla">Getting started</h2>
      </div>

      {/* progress bar */}
      <div>
        <div className="flex justify-between text-xs text-echo-blue mb-1.5">
          <span>{doneCount} of {steps.length} complete</span>
          <span className="font-semibold text-medium-slate-blue">{pct}%</span>
        </div>
        <div className="w-full h-1.5 bg-lavender rounded-full overflow-hidden">
          <div
            className="h-full rounded-full bg-medium-slate-blue transition-all duration-500"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      <ul className="flex flex-col gap-3">
        {steps.map((step) => {
          const done = doneMap[step.key];
          return (
            <li key={step.key} className="flex items-center gap-3 group">
              {done
                ? <CheckCircleSolid className="w-5 h-5 text-medium-slate-blue flex-shrink-0" />
                : <CheckCircleIcon className="w-5 h-5 text-echo-blue flex-shrink-0" />
              }
              <span className={`text-sm flex-1 ${done ? 'text-valhalla line-through opacity-50' : 'text-valhalla'}`}>
                {step.label}
              </span>
              {!done && (
                <Link to={step.to} className="opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowTopRightOnSquareIcon className="w-4 h-4 text-medium-slate-blue" />
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default connect((state: any) => ({
  currentUser: state.setting.get('currentUser'),
  products: state.product.get('products'),
  employeeList: state.employee.get('employeeList'),
}))(HelpGuide);
